const CERTIFICATE_MAX_COUNT = 6

function canAddCertificateFiles(currentCount, selectedCount) {
  return currentCount + selectedCount <= CERTIFICATE_MAX_COUNT
}

function limitCertificateFiles(fileList) {
  return (fileList || []).slice(0, CERTIFICATE_MAX_COUNT)
}

module.exports = {
  CERTIFICATE_MAX_COUNT,
  canAddCertificateFiles,
  limitCertificateFiles,
}
